import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-11-25
	search(params) {
		return axios.get('/rents?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-11-25
	findBySerialNo(params) {
		return axios.get('/rents/find-by-serial-no', params);
	},
	// 2020-11-26
	create(params) {
		return axios.post('/rents', params);
	},
	// 2021-06-16
	createClean(params) {
		return axios.post('/rents/clean', params);
	},
	// 2020-11-25
	delete(id) {
		return axios.delete('/rents/' + id)
	},
	// 2020-11-25
	update(id, params) {
		return axios.put('/rents/' + id, params);
	},
	// 2020-11-26
	updataOwner(params) {
		return axios.put('/rents/update-owner', params);
	},
	// // 2021-02-02
	// searchSchedule(params) {
	// 	return axios.get('/rents/search-schedule', params);
	// },
	// 2021-02-27
	searchSchedule(params) {
		return axios.get('/rents/items/search-schedule', params);
	},
	// 2021-03-22
	exportExcel(params) {
		return axios.get('/rents/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-11-25
	findById(id) {
		return axios.get('/rents/' + id);
	}
}

